module.exports = __webpack_public_path__ + "img/icon-activity-active.f9cc7ad3.svg";